import React, { useState } from "react";
import { withStyles } from "@material-ui/core/styles";
import Snackbar from "@material-ui/core/Snackbar";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";

const NotificationContext = React.createContext({
  openNotification: () => {}
});

const styles = theme => ({
  close: {
    padding: theme.spacing.unit / 2
  }
});

const Notification = ({ classes, children }) => {
  const [values, setValues] = useState({
    open: false,
    message: ""
  });

  const handleOpen = message => {
    setValues({
      open: true,
      message
    });
  };

  const handleClose = () => {
    setValues({
      open: false,
      message: ""
    });
  };

  const { message, open } = values;

  return (
    <NotificationContext.Provider value={handleOpen}>
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left"
        }}
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        ContentProps={{
          "aria-describedby": "message-id"
        }}
        message={<span id="message-id">{message}</span>}
        action={[
          /*<Button
            key="undo"
            color="secondary"
            size="small"
            onClick={handleClose}
          >
            Cerrar
          </Button>,*/
          <IconButton
            key="close"
            aria-label="Close"
            color="inherit"
            className={classes.close}
            onClick={handleClose}
          >
            <CloseIcon />
          </IconButton>
        ]}
      />
      {children}
    </NotificationContext.Provider>
  );
};

export function withNotification(InnerComponent) {
  return props => (
    <NotificationContext.Consumer>
      {handleOpen => (
        <InnerComponent openNotification={handleOpen} {...props} />
      )}
    </NotificationContext.Consumer>
  );
}

export default withStyles(styles)(Notification);



// WEBPACK FOOTER //
// ./src/components/notification/context.js